import { Injectable } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { TealiumAnalyticsService } from '@ddt-web/analytics';

import { PopupDialogAction, PopupDialogObject } from '../models';
import { ErrorHelperService } from './error-helper.service';
import { ErrorPopupService } from './error-popup.service';

@Injectable()
export abstract class AbstractErrorHandlerService {
	protected errorMessage: string;
	protected errorSeverity: string;
	protected trackErrorMessage: string;
	protected actionMessage: string;
	protected actionLabel: string;
	protected actionType: string;
	protected nextHandler: AbstractErrorHandlerService;
	protected httpRequestId: string;

	constructor(
		protected contentService: ContentService,
		protected errorPopupService: ErrorPopupService,
		protected tealiumAnalyticsService: TealiumAnalyticsService,
		protected errorHelperService: ErrorHelperService
	) {
		this.nextHandler = {
			handleError: error => {
				console.error('There was an error not caught by any existing handler ', error);
				this.handleErrorTracking(this.trackErrorMessage, this.errorSeverity);
			}
		} as AbstractErrorHandlerService;
	}

	public abstract handleError(error: any): void;

	public setNextHandler(next: AbstractErrorHandlerService): AbstractErrorHandlerService {
		this.nextHandler = next;
		return this.nextHandler;
	}

	public getNextHandler(): AbstractErrorHandlerService {
		return this.nextHandler;
	}

	protected buildErrorMessage(
		success: boolean = false,
		dialogClass: string = 'error-handler-dialog',
		title: string = '',
		trackMsgPrefix: string = this.errorSeverity,
		description: string = this.errorMessage,
		disableClose: boolean = true,
		listings: Array<any> = [],
		actions: PopupDialogAction[] = [
			PopupDialogAction.create({
				description: this.actionMessage,
				label: this.actionLabel,
				type: this.actionType,
				reload: true
			})
		],
		requestId: string = this.httpRequestId
	): PopupDialogObject {
		return PopupDialogObject.create({
			success: success,
			dialogClass: dialogClass,
			title: title,
			trackMsgPrefix: trackMsgPrefix,
			description: description,
			disableClose: disableClose,
			listings: listings,
			actions: actions,
			requestId: requestId
		});
	}

	protected handleErrorTracking(trackErrorMessage: string, errorSeverity: string): void {
		this.tealiumAnalyticsService.trackError(trackErrorMessage, errorSeverity);
	}
}
